import React from "react";

function TermsAndConditions() {
  return (
    <div>
      <h1 className="text-3xl font-bold nav">Terms And Conditions</h1>
      <p >Terms & Conditions</p>
    </div>
  );
}

export default TermsAndConditions;
